export default __webpack_public_path__ + "static/media/partner-red.2911ebf9.svg";